import { useEffect } from "react";

/* Фильтры «жидкого стекла». backdrop-filter: url(#...) преломляет то, что лежит под
   элементом; умеет только Chromium, поэтому класс lg-refract на <html> ставим только там.
   В Safari и Firefox остаётся размытие с насыщением, выглядит тоже как стекло, но без изгиба.

   Карта смещения собирается из двух градиентов: R двигает по горизонтали, G по вертикали.
   lg-refract: смещение только у краёв (стекло изгибает кромку, середина чистая). */
const svg = (inner) => `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" preserveAspectRatio="none">${inner}</svg>`,
)}`;

const grad = (id, x2, y2, stops) =>
  `<linearGradient id="${id}" x1="0" y1="0" x2="${x2}" y2="${y2}">${stops
    .map(([o, c]) => `<stop offset="${o}" stop-color="${c}"/>`)
    .join("")}</linearGradient>`;

const mapX = (stops) => svg(`<defs>${grad("g", 1, 0, stops)}</defs><rect width="100" height="100" fill="url(#g)"/>`);
const mapY = (stops) => svg(`<defs>${grad("g", 0, 1, stops)}</defs><rect width="100" height="100" fill="url(#g)"/>`);

const EDGE_X = mapX([[0, "rgb(235,128,128)"], [0.16, "rgb(128,128,128)"], [0.84, "rgb(128,128,128)"], [1, "rgb(21,128,128)"]]);
const EDGE_Y = mapY([[0, "rgb(128,235,128)"], [0.16, "rgb(128,128,128)"], [0.84, "rgb(128,128,128)"], [1, "rgb(128,21,128)"]]);

const Displace = ({ id, mx, my, scale }) => (
  <filter id={id} x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
    <feImage href={mx} x="0" y="0" width="100%" height="100%" preserveAspectRatio="none" result="mx" />
    <feImage href={my} x="0" y="0" width="100%" height="100%" preserveAspectRatio="none" result="my" />
    <feColorMatrix in="mx" type="matrix" values="1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0 1" result="r" />
    <feColorMatrix in="my" type="matrix" values="0 0 0 0 0  0 1 0 0 0  0 0 0 0 0  0 0 0 0 1" result="g" />
    <feComposite in="r" in2="g" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="map" />
    <feDisplacementMap in="SourceGraphic" in2="map" scale={scale} xChannelSelector="R" yChannelSelector="G" />
  </filter>
);

export const GlassFilters = () => {
  useEffect(() => {
    const ua = navigator.userAgent;
    const chromium = /Chrome|Chromium|Edg\//.test(ua) && !/Firefox/.test(ua);
    document.documentElement.classList.toggle("lg-refract", chromium);
    return () => document.documentElement.classList.remove("lg-refract");
  }, []);

  return (
    <svg aria-hidden="true" width="0" height="0" style={{ position: "absolute" }} focusable="false">
      <defs>
        <Displace id="lg-refract" mx={EDGE_X} my={EDGE_Y} scale={46} />
      </defs>
    </svg>
  );
};
